exports.editSlotOrSeries = require("./edit");
exports.deleteSlotOrSeries = require("./delete");
